import { render, staticRenderFns } from "./MkcCollapse.vue?vue&type=template&id=55d3a1e6&scoped=true"
import script from "./MkcCollapse.vue?vue&type=script&lang=js"
export * from "./MkcCollapse.vue?vue&type=script&lang=js"
import style0 from "./MkcCollapse.vue?vue&type=style&index=0&id=55d3a1e6&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d3a1e6",
  null
  
)

export default component.exports